export default __webpack_public_path__ + "static/10.Mamre Oasks-36ecbe1f26c0b90f062dc3ffb3ca2952.png";